module.exports = __webpack_public_path__ + "static/img/taua-nazareth.699da7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taua-nazareth.jpg
// module id = qXqi
// module chunks = 0